import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EmbedParams } from '../../_objects/embedded-report';
import { EmbeddedReportContractService } from '../interfaces/embedded-report-contract.service';

@Injectable({
  providedIn: 'root'
})
export class EmbeddedReportOfflineService implements EmbeddedReportContractService {

  constructor() { }
  // ER01 GET /api/powerbi/report
  getEmbeddedReport(): Observable<EmbedParams> {
    return of();
  }
}
